<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Coupons"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="only_first_purchase"
                rules="required"
                v-slot="{ errors }"
              >
                <v-checkbox
                  :error-messages="errors"
                  v-model="data.only_first_purchase"
                  label="First purchase"
                  color="indigo"
                  hide-details
                ></v-checkbox>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="discount"
                rules="required|between:0,100"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.discount"
                  min="0"
                  label="Discount"
                  type="number"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="name"
                rules="required|max:80"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  label="Name"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider 
                ref="legal" 
                rules="required" 
                v-slot="{ errors }"
              >
                <v-text-field
                    :error-messages="errors"
                    v-model="data.legal"
                    label="Legal"
                    prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="code"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.code"
                  label="Code"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="quantity_count_use"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.quantity_count_use"
                  label="Quantity use"
                  type="number"
                  prepend-inner-icon="fas fa-file"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                  ref="infinite"
                  rules="required"
                  v-slot="{ errors }"
              >
                <v-checkbox
                    :error-messages="errors"
                    v-model="data.infinite"
                    label="Infinite"
                    color="indigo"
                    hide-details
                ></v-checkbox>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="company_id"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="data.company_id"
                  :multiple="!$route.params.id"
                  label="Company"
                  :items="companies"
                  item-text="name"
                  item-value="id"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="region_id"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="data.region_id"
                  label="Region"
                  :items="regions"
                  :multiple="!$route.params.id"
                  :disabled="!can_select_region"
                  item-text="name"
                  item-value="id"
                >
                  <template v-slot:item="{item}">
                    <v-checkbox class="mb-4" :value="data.region_id.indexOf(item.id)!==-1" :hide-details="true">
                      <template v-slot:label>
                        <div>
                          {{item.name}}
                          <br>
                          <p class="orange--text mb-0">{{item.company_id.name}}</p>
                        </div>
                      </template>
                    </v-checkbox>
                  </template>
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col cols="1" v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-col>
          </v-row>

          <v-row v-if="role == 'admin'">
            <v-col>
              <ValidationProvider ref="categories" rules="" v-slot="{ errors }">
                <v-select
                    :error-messages="errors"
                    v-model="data.category_id"
                    label="Sponsored brand"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="products"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="data.products"
                  label="Products"
                  :items="products"
                  :disabled="!can_select_product"
                  item-text="name"
                  item-value="id"
                  multiple
                >
                  <template v-slot:item="{item}">
                    <v-checkbox class="mb-4" :value="data.products.indexOf(item.id)!==-1" :hide-details="true">
                      <template v-slot:label>
                        <div>
                          {{item.name}}
                          <br>
                          <p class="orange--text mb-0">{{item.company_id.name}}</p>
                        </div>
                      </template>
                    </v-checkbox>
                  </template>
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="init_time" rules="" v-slot="{ errors }">
                <v-menu
                  ref="menu_dead_line"
                  v-model="menu_init_time"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  :error-messages="errors"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.init_time"
                      label="Date of init_time"
                      prepend-icon="fas fa-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="init_time"
                    label="Project Duration"
                    type="date"
                    no-title
                    scrollable
                    @change="menu_init_time = false"
                  ></v-date-picker>
                </v-menu>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="finish_time"
                rules=""
                v-slot="{ errors }"
              >
                <v-menu
                  ref="menu_dead_line"
                  v-model="menu_finish_time"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  :error-messages="errors"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.finish_time"
                      label="Date of finish_time"
                      prepend-icon="fas fa-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="finish_time"
                    label="Project Duration"
                    type="date"
                    no-title
                    scrollable
                    @change="menu_finish_time = false"
                  >
                  </v-date-picker>
                </v-menu>
              </ValidationProvider>
            </v-col>
          </v-row>
<!--          <v-row>
            <v-col>
              <ValidationProvider ref="icon" rules="" v-slot="{ errors }">
                <Upload
                  :error-messages="errors"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Icon"
                  prepend-icon="fas fa-camera"
                  label=""
                  :multiple="false"
                  :onSelectedPicture="onSelectedIcon"
                >
                </Upload>
                <div v-if="imageLoaded"  style="color: #fc3400">
                  Image size is {{image.size}}<br/>
                  Image width and height is {{image.width}} / {{image.height}} , required a square image of {{ MIN_WIDTH }}px to {{MAX_WIDTH}}px
                </div>
                <v-img :src="icon" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>-->
          <v-row>
            <v-col>
              <SimpleUploadCrop
                label="Icon"
                :onSelectedPicture="selectPicture"
                :max-width-dimension="160"
                :max-height-dimension="300"
                :zoom-crop="0"
                :resize_limit_width="160"
                :resize_limit_height="300"
                :enable-resize-crop="false"
              />
              <div>
<!--              <span class="file_c" style="color: #ff3300">Current image: {{ current_image }}</span>-->
<!--              <br>-->
              <span class="file_c" style="color: #ff3300">Preferred image size is 160 x 300 </span>
              </div>
              <img v-if="tmp_icon" :src="tmp_icon" width="160">
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col>
              <ValidationProvider ref="picture" rules="" v-slot="{ errors }">
                <Upload
                  :error-messages="errors"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Picture"
                  prepend-icon="fas fa-camera"
                  label=""
                  :multiple="false"
                  :onSelectedPicture="onSelectedPicture"
                >
                </Upload>
                <v-img :src="picture" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row> -->
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import Upload from "@/components/Upload";
import SimpleUploadCrop from "@/components/SimpleUploadCrop"

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm, Upload, SimpleUploadCrop },
  computed: {
    ...mapState({
      status: state => state.Coupons.status,
      stores: state => state.Stores.list,
      regions: state => state.Regions.list,
      products: state => state.Products.list,
      categories: state => state.Categories.list,
      companies: state => state.Companies.list,
      role: state => state.Authenticate.role
    }),
    selected_stores(){ return this.data.region_id}
  },
  data() {
    return {
      storeName: "Coupons",
      filteredAttributes: ["icon", "picture"],
      title: "Coupon",
      icon: "",
      loading: false,
      current_icon:null,
      tmp_icon:null,
      data: {
        code: "",
        region_id: "",
        company_id: "",
        coupon_products: [],
        products: [],
        discount: "",
        only_first_purchase: false,
        infinite: false,
        init_time: "",
        finish_time: "",
        category_id: "",
        icon: undefined,
        name: "",
        quantity_count_use: "",
        legal: '',
      },
      init_time: "",
      menu_init_time: false,
      finish_time: "",
      menu_finish_time: false,
      can_select_region: false,
      can_select_product:false,
      current_image:'',
      image:{
        size:'',
        height:'',
        width:''
      },
      MAX_SIZE:500000,
      MAX_WIDTH:150,
      MAX_HEIGHT:150,
      MIN_WIDTH:100,
      MIN_HEIGHT:100,
      imageLoaded:false,
      imageError:''
    };
  },
  watch: {
    init_time(val) {
      this.init_time = val;
      this.data.init_time = this.formatDateForSave(val);
    },
    finish_time(val) {
      this.finish_time = val;
      this.data.finish_time = this.formatDateForSave(val);
    },
    "data.company_id"(val) {
      const self = this;
      self.can_select_region = true;

      self.loading = true;
      self.$store
        .dispatch("Regions/getListAll", {
          show_all: "enable",
          company_id: val
        })
        .then(regions => {
          const region = regions.find(
            elm => elm.company_id.id == self.data.company_id
          );
          console.log(region);
          if (!region) {
            self.data.region_id = "";
          } else {
            //    self.data.region_id=region.region_id
          }
          const region_id = regions.find(
            elm => elm._id === self.data.region_id
          );
          if (!region_id) self.data.region_id = "";
          if (!regions || regions.length === 0) self.data.region_id = "";
          self.loading = false;
        });
      if(val && self.data.category_id) {
        self.can_select_product = true;
        self.data.products = [];
        self.$store.dispatch("Products/getListAll",
            {
              show_all: "enable",
              company_id: val,
              category_id: self.data.category_id
            });
      }
    },
    "data.category_id"(val){
      const self = this;
      if(val && self.data.company_id) {
        self.can_select_product = true;
        self.data.products = [];
        self.$store.dispatch("Products/getListAll",
            {
              show_all: "enable",
              company_id: self.data.company_id,
              category_id: val
            });
      }
    },
    tmp_icon:{
      handler(val){
        const self = this
        if(val){
          const img = new Image();
          img.onload = function() {
            self.current_image = this.width + 'x' + this.height
          }
          img.src = val
        }
      },
      immediate:true
    }
  },

  async created() {
    const self = this;
    await self.$store.dispatch("Stores/getListAll", { show_all: "enable" });

    await self.$store.dispatch("Categories/getListAll", { show_all: "enable" });
    await self.$store.dispatch("Companies/getListAll", { show_all: "enable" });
    await self.$store.dispatch("Regions/getListAll", { show_all: "enable" });
    if (self.$route.params.store_id)
      self.data.store_id = self.$route.params.store_id;
    if (self.$route.params.id) {
      self.$store
        .dispatch(`${self.storeName}/show`, self.$route.params.id)
        .then(async function(data) {
          if(data.company_id){
            await self.$store.dispatch("Regions/getListAll", { show_all: "enable",company_id:data.company_id });
          }
          self.tmp_icon = data.icon;
          for (let i in data) {
            if (
              self.data[i] !== undefined &&
              !self.filteredAttributes.includes(i)
            ) {
              self.data[i] = data[i];
            } else {
              if (
                self.filteredAttributes.includes(i) &&
                self[i] !== undefined
              ) {
                self[i] = data[i];
              }
            }
          }

          //for edit: add product_id a products of coupon_products
          data.product_id.forEach(element => {
            self.data.products.push(element.product_id);
          });
        });
      this.rule_password = "min:4";
    }
  },
  methods: {
    allowedHours: v => v % 2,
    allowedMinutes: v => v >= 10 && v <= 50,
    allowedStep: m => m % 10 === 0,
    selectPicture(file){
      const self = this
      if(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function() {
          self.tmp_icon = reader.result;
        }
        this.data.icon = file
      }
    },
    async onSelectedIcon(file) {
      const self = this;
      if (file) {
        let dim = await self.getDimensionsFile(file);
        self.imageLoaded = true;
        self.image.width = dim.width;
        self.image.height = dim.height;
        if ((dim.width === dim.height) && (dim.width <= self.MAX_WIDTH && dim.width >= self.MIN_WIDTH) && (dim.height <= self.MAX_HEIGHT && dim.height >= self.MIN_HEIGHT)) {
          self.imageLoaded = false;
          this.data.icon = file;

          let fr = new FileReader();
          fr.onload = function () {
            self.icon = fr.result;
          };
          fr.onerror = function () {
            self.icon = "";
          };
          fr.readAsDataURL(this.data.icon);

        } else {
          self.icon = "";
          this.data.icon = "";
        }
      }
    },
    getDimensionsFile(file){
      return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (fe) => {
        const image = new Image();
        image.src = fe.currentTarget.result;
        image.onload = function(ie){
          let dimensions;
          if(ie.target){
            dimensions = {
              width: ie.target.width,
              height:  ie.target.height
            };
          }else{
            dimensions = {
              width: ie.path[0].width,
              height:  ie.path[0].height
            };
          }
          resolve(dimensions);
        }
      };
      reader.onerror = error => reject(error);
    });
    }
   /*  onSelectedPicture(file) {
      const self = this;
      if (file) {
        this.data.picture = file;

        let fr = new FileReader();
        fr.onload = function() {
          self.picture = fr.result;
        };
        fr.onerror = function() {
          self.picture = "";
        };
        fr.readAsDataURL(this.data.picture);
      }
    } */
  }
};
</script>
